import { module as BaseModule } from 'modujs'
import { gsap } from 'gsap'
import { Observer } from 'gsap/Observer'

gsap.registerPlugin(Observer)

export default class extends BaseModule {
  constructor(m) {
    super(m)
    this.events = {
      click: {
        background: 'closeMenu',
      },
    }
  }

  init() {
    this.btns = this.el.querySelectorAll('[data-navigation="btn"]')
    this.btns.forEach((btn, i) => {
      btn.addEventListener('click', () => {
        console.log('click', i)
        this.toggleMenu(i)
      })
    })

    this.menus = document.querySelectorAll('[data-navigation="submenu"]')
    this.menus.forEach((menu) => {
      gsap.set(menu, { autoAlpha: 0 })
    })

    this.openState = false
    this.currentIndex = false
    this.isTransiting = false

    this.setTimeline()

    window.headerOffset = this.el.offsetHeight

    document.addEventListener('page:change', () => {
      // console.log('close menu')
      this.closeMenu()
    })
  }

  setObserver() {
    Observer.create({
      target: window,
      type: 'wheel,touch',
      onChange: (self) => {
        if (self.scrollY() > window.innerHeight * 0.25) {
          this.el.setAttribute('data-header', '')
        } else {
          this.el.removeAttribute('data-header')
        }
      },
    })
  }

  setTimeline() {
    this.panelTimeline = gsap
      .timeline({
        yoyo: true,
        paused: true,
      })
      .set('.c-header__menu', {
        autoAlpha: 1,
      })
      .to('.c-header__panel', {
        xPercent: '100',
        duration: 0.35,
        ease: 'power1.out',
      })
      .to(
        '.c-header__background',
        {
          autoAlpha: 1,
          duration: 0.35,
          ease: 'power2.out',
        },
        '<',
      )
  }

  toggleMenu(i) {
    if (i === this.currentIndex && this.openState) {
      this.closeMenu(i)
    } else {
      this.openMenu(i)
    }
  }

  async closeMenu() {
    if (!this.openState) return
    this.panelTimeline.reverse()
    this.openState = false
  }

  async openMenu(i) {
    console.log('openMenu', i, this.currentIndex)
    if (!this.openState) {
      this.panelTimeline.play()
      this.openState = true
    }

    const tl = gsap.timeline({ duration: 0.2 })

    if (this.currentIndex !== false) tl.to(this.menus[this.currentIndex], { autoAlpha: 0, duration: 0.1 })
    tl.to(this.menus[i], { autoAlpha: 1 })

    this.currentIndex = i
    this.btns.forEach((btn, i) => btn.setAttribute('aria-expanded', i === this.currentIndex))
  }
}
